import React from 'react'
import './about.css'
import Me from '../../assets/Me.jpeg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {AiOutlineFundProjectionScreen} from 'react-icons/ai'

function about() {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className='container about_container'>
        <div className='about_me'>
         <img src={Me} alt='About image'/>
        </div>
        <div className='about_content'>
           <div className='about_cards'>
            <article className='about_card'>
              <FaAward className='about_icon'/>
              <h5>Experince</h5>
              <small>1+</small>
            </article>

            <article className='about_card'>
              <FiUsers className='about_icon'/>
              <h5>Clients</h5>
              <small>300+ world wide</small>
            </article>

            <article className='about_card'>
              <AiOutlineFundProjectionScreen className='about_icon'/>
              <h5>Projects</h5>
              <small>6+ Completed</small>
            </article>
           </div>
           <p>In publishing and graphic design, Lorem ipsum is a placeholder 
            text commonly used to demonstrate the visual form of a document
             or a typeface without relying on meaningful content. Lorem ipsum may be 
             used as a placeholder before final copy is available</p>

             <a href='#contact' className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default about